import React from 'react'
import styles from './style.module.scss'

export const PageWrapper = ({ children }) => {
  return <div className={styles.wrapper}>{children}</div>
}
